import { createAction, props } from '@ngrx/store';
import { ResponseValidateSession } from '../../shared/interfaces';
import { validateSessionTypes } from '../../shared/enums';


export const getValidateSession = createAction(
    validateSessionTypes.VALIDATE_SESSION,
    props<{ request: any }>()
);

export const getValidateSessionSuccess = createAction(
    validateSessionTypes.VALIDATE_SESSION_SUCCESS,
    props<{ response: ResponseValidateSession }>()
);

export const getValidateSessionError = createAction(
    validateSessionTypes.VALIDATE_SESSION_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    validateSessionTypes.CLEAN_STATE
);
